.button {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    gap: 8px;
    padding: var(--spacing-xxs) var(--spacing-xs);
    border: 1px solid transparent;
    border-radius: 32px;
    box-sizing: border-box;
    background-color: transparent;
    color: var(--colorTextPrimary);
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
    cursor: pointer;
    outline: none;
}

.button[data-hovered],
.button[data-pressed] {
    opacity: 0.7;
}

.button[data-focus-visible] {
    border-color: var(--colorBorderAccent);
}

.button[data-disabled] {
    opacity: 0.4;
    cursor: default;
}

.chevron {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: transform 150ms ease;
}

.button[aria-expanded='true'] .chevron {
    transform: rotate(180deg);
}
